export const beautifyLabel = (key) => {
  console.log("key:", key);

  return key
    ?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    ?.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatExperience = (totalMonths) => {
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  let experienceText = "";
  if (years > 0) {
    experienceText += `${years} ${years > 1 ? "Years" : "Year"}`;
  }
  if (months > 0) {
    experienceText += ` ${months} ${months > 1 ? "Months" : "Month"}`;
  }
  if (totalMonths === 0) {
    return "Fresher/Intern/Trainee";
  }
  return experienceText.trim();
};


export const getOperatorsForField = (conditionFields,fields ) => {
  return fields.find(f=> f.name === conditionFields.field)?.operators ||[]
}
